import logoPath from '../../../assets/images/navigation/toke-logo.svg';
import logoWhite from '../../../assets/images/navigation/toke-logo-white.svg';
import iconPath from '../../../assets/images/navigation/icon-app.svg';
import slide1 from "../../../assets/images/navigation/paga-con-dinero.png";
import slide2 from "../../../assets/images/navigation/haz-tu-recargas.png";
import chatIcon from "../../../assets/images/navigation/messages-2.svg"



export const navigation = {
    logo: {
        alt: 'Logo Toke',
        default: logoWhite,
        sticky: logoPath,
    },

    menu: [
        {
            id: '1',
            label: 'Toke pa’ ti',
            url: '/#negocio-2'
        },
        {
            id: '2',
            label: 'Toke pa’ tu negocio',
            url: '/#negocio-1',
        },
        {
            id: '3',
            label: 'FAQ',
            url: '/#preguntas',
        },
        // {
        //     id: '4',
        //     label: 'Conócenos',
        //     url: '/#ventajas',
        //     menuLabel: "conocenos",
        //     subMenu: [
        //         {
        //             label: 'Quiénes somos',
        //             url: '/conocenos/quienes-somos'
        //         },
        //         {
        //             label: 'Misión, visión y valores',
        //             url: '/conocenos/mision-vision-valores'
        //         },
        //         {
        //             label: 'Nuestro equipo',
        //             url: '/conocenos/nuestro-equipo'
        //         },
        //     ]
        // }
    ],

    popUp: {
        icon: {
            src: iconPath,
            alt: "Icono de aplicación"
        },
        description: "<p>Paga y cobra de forma </br> fácil y rápida.</p>",
        CTA: "Descarga la App",
        link: "www.google.com"
    },

    slideRec: [
        {
            id: 1,
            image: slide2,
            alt: "Paga Directo a un numero celular"
        },
        {
            id: 2,
            image: slide2,
            alt: "Haz tus recargas con Toke"

        }
    ],

    mobileActions: [
        {
            id: '2',
            label: 'Descarga Toke',
            url: '/',
            color: "morado",

        },
        {
            id: '2',
            icon: chatIcon,
            label: 'Chat toke',
            url: '/',
            color: ""
        }
    ]



};